// extracted by mini-css-extract-plugin
export default {"upperHeadingTitle":"styles_upperHeadingTitle__WHjrN","upperHeadingText":"styles_upperHeadingText__9tylY","CodePill":"styles_CodePill__9rlaV","seperator":"styles_seperator__+djsE"};